<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt Dịch Vụ Bếp</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <v-col cols="12">
        <v-checkbox
          hide-details
          value="view-dish-service-group"
          :label="'Cho phép ' + roleName + ' thiết lập dịch vụ bếp'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- món ăn -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-dishes"
          :label="'Cho phép ' + roleName + ' thiết lập món ăn'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- thực đơn -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="food-menu-list"
          :label="'Cho phép ' + roleName + ' thiết lập thực đơn hàng tuần'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- danh sách đăng kí -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="student-register-list"
          :label="'Cho phép ' + roleName + ' xem danh sách học viên đăng kí'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-student-register"
          :label="'Cho phép ' + roleName + ' sửa thực đơn của Học viên'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- báo cáo suất ăn -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="meal-report"
          :label="'Cho phép ' + roleName + ' xem báo cáo suất ăn'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>

<style scoped></style>
